import { Directive, ElementRef, HostListener, Input, TemplateRef } from '@angular/core'

@Directive({
	selector: 'span[data-popover]',
	standalone: true,
	exportAs: 'popoverControl',
})
export class PopoverDirective {
	@Input('appPopoverTemplate')
	popoverTemplate?: TemplateRef<any>

	public visible: boolean = false

	constructor(public readonly el: ElementRef) {}

	@HostListener('pointerenter')
	public handlePointerEnter(): void {
		this.visible = true
	}

	@HostListener('pointerleave')
	public handlePointerLeave(): void {
		this.visible = false
	}
}
